module.exports = __webpack_public_path__ + "static/media/search.cc27d279.svg";